import { useContext } from 'react';
import { pageErrorContext } from './pageErrorContext';

export const usePageError = () => {
  const context = useContext(pageErrorContext);

  if (!context) {
    throw new Error('usePageError must be used within a PageErrorProvider');
  }

  return context;
};
